import InformationValidation from "../validations/InformationValidation";
import BillingValidation from "../validations/BillingValidation";
import ValidateForm from "../validations/ValidateForm";
import addCustomFieldsValidation from "../validations/addCustomFieldsValidation";

export const digitalFlowSteps = ["information", "billing"];
export const noDigitalFlowSteps = ["information", "shipping", "billing"];

const informationUrl = "/v2/checkout/information/" + window.token;
const shippingUrl = "/v2/checkout/shipping/" + window.token;
const billingUrl = "/v2/checkout/billing/" + window.token;
const verticalUrl = "/v2/checkout/vertical/" + window.token;

const digitalFlowData = {
  information: {
    url: informationUrl,
  },
  billingAndPayment: {
    url: billingUrl,
    previousStep: "information",
  },
};

const noDigitalFlowData = {
  information: {
    url: informationUrl,
  },
  shipping: {
    url: shippingUrl,
    previousStep: "information",
  },
  billinAndPayment: {
    url: billingUrl,
    previousStep: "shipping",
  },
};

function shippingValidation(shipping) {
  if (Object.keys(shipping).length === 0) return false;

  let shippingResult = shipping.shipping_ids.shipping_method_id;

  return !Number.isNaN(shippingResult);
}

function billingValidation(information, billing, system_fields, patterns) {
  if (
    Object.keys(information).length === 0 ||
    Object.keys(billing).length === 0
  )
    return false;

  let validationData;

  if (information.no_shipping_required) {
    validationData = Object.assign(
      {},
      billing,
      {
        no_shipping_required: information.no_shipping_required,
        phone: information.phone,
      },
      system_fields,
      patterns,
    );
  } else {
    validationData = Object.assign({}, billing, system_fields, patterns);
  }

  const allCustomFields = information.billing_same_as_shipping
    ? []
    : information.custom_fields.billing;
  const { validations, updatedData } = addCustomFieldsValidation(
    allCustomFields,
    validationData,
    BillingValidation,
  );

  let result = ValidateForm(validations, updatedData);

  return result.status;
}

function digitalInformationValidation(billing, information) {
  if (Object.keys(billing).length === 0) return false;
  const otherCustomFields = information.custom_fields.other;
  const contactCustomFields = information.custom_fields.contact;
  let allCustomFields = otherCustomFields.concat(contactCustomFields);

  let validationData = Object.assign({}, billing, {
    no_shipping_required: information.no_shipping_required,
    email: information.email,
    name: information.name,
    surname: information.surname,
    country: information.country,
    show_billing_address_on_digital_products:
      information.show_billing_address_on_digital_products,
  });

  const { validations, updatedData } = addCustomFieldsValidation(
    allCustomFields,
    validationData,
    InformationValidation,
  );
  let result = ValidateForm(validations, updatedData);

  return result.status;
}

function noDigitalInformationValidation(information, system_fields) {
  let validationData;
  let allCustomFields;
  const shippingCustomFields = information.custom_fields.shipping;
  const otherCustomFields = information.custom_fields.other;
  const contactCustomFields = information.custom_fields.contact;

  validationData = Object.assign({}, information, system_fields);
  allCustomFields = shippingCustomFields
    .concat(otherCustomFields)
    .concat(contactCustomFields);

  const { validations, updatedData } = addCustomFieldsValidation(
    allCustomFields,
    validationData,
    InformationValidation,
  );
  let result = ValidateForm(validations, updatedData);

  return result.status;
}

const CheckStep = (state, currentUrl) => {
  const isEntryStep = currentUrl.includes("information");
  const isExitStep = currentUrl.includes("success");

  if (!state.checkoutStore.information.checkout_multipage_form)
    return verticalUrl;

  if (isEntryStep || isExitStep) return false;

  const isDigital = state.checkoutStore.information.no_shipping_required;
  let currentFlow = isDigital ? digitalFlowSteps : noDigitalFlowSteps;
  let currentFlowData = isDigital ? digitalFlowData : noDigitalFlowData;
  const stepExists = currentFlow.some((current) =>
    currentUrl.includes(current),
  );

  if (!stepExists) return informationUrl;

  const information = state.checkoutStore.information;
  const shipping = state.checkoutStore.shipping;
  const billing = state.checkoutStore.billing;
  const system_fields = state.checkoutStore.system_fields;
  const patterns = state.checkoutStore.patterns;

  const firstStep = Object.keys(currentFlowData).find((key) => {
    if (currentUrl.includes(currentFlowData[key].url)) {
      return key;
    }
  });

  // Check all previous steps to see if they are all valid
  let stepsList = [];
  addPreviousStep(currentFlowData[firstStep]);
  stepsList.reverse();

  function addPreviousStep(currentStep) {
    if ("previousStep" in currentStep) {
      let previousStep = currentFlowData[currentStep.previousStep];
      stepsList.push(currentStep.previousStep);
      addPreviousStep(previousStep);
    }
    return;
  }

  let redirectUrl;

  stepsList.forEach((step) => {
    switch (step) {
      case "shipping":
        if (!shippingValidation(shipping)) {
          redirectUrl = currentFlowData[step].url;
          return;
        }
        break;
      case "billinAndPayment":
        if (!billingValidation(information, billing, system_fields, patterns)) {
          redirectUrl = currentFlowData[step].url;
          return;
        }
        break;
      case "information":
        if (isDigital) {
          if (!digitalInformationValidation(billing, information)) {
            redirectUrl = currentFlowData[step].url;
            return;
          }
        } else {
          if (!noDigitalInformationValidation(information, system_fields)) {
            redirectUrl = currentFlowData[step].url;
            return;
          }
        }
        break;
      default:
        break;
    }
  });

  if (redirectUrl) return redirectUrl;

  return false;
};

export default CheckStep;
